import ProfileActions from '../../../components/common/ProfileActions';
import { useRestaurantContext } from '../../../contexts/RestaurantContext';
import { PAGE_LOCATION_PROFILE } from '../../../constants/UriConstants';

interface LocationProfileActionsProps {
  onSave?: () => void;
  submit?: boolean;
  isSaving?: boolean;
  isDisabled?: boolean;
}

const LocationProfileActions = ({ onSave, submit, isSaving, isDisabled }: LocationProfileActionsProps) => {
  const { currentRestaurant } = useRestaurantContext();

  return (
    <ProfileActions
      cancelTo={`/${PAGE_LOCATION_PROFILE}/${currentRestaurant?.restaurantID}`}
      onSave={onSave}
      submit={submit}
      isSaving={isSaving}
      isDisabled={isDisabled}
    />
  );
};

export default LocationProfileActions;
